import React from 'react'
import cx from 'classnames'
import styles from './Field.css'

const FormField = ({
  className,
  label,
  labelClassName,
  contentClassName,
  children,
  ...rest
}) => (
  <div className={cx(styles.formField, className)} {...rest}>
    <span className={cx(styles.formFieldLabel, labelClassName)}>{label}</span>
    <div className={cx(styles.formFieldContent, contentClassName)}>
      {children}
    </div>
  </div>
)

export default FormField



// WEBPACK FOOTER //
// ./src/components/Form/Field.js